export default __webpack_public_path__ + "static/media/926.952edf12.png";